/// <reference path="../../../../typings/index.d.ts" />
angular.module('app').factory('SimulationDataDesignerServiceApi', ($http, ApiErrorService) => {
    return {
        getAvailableLibraries: getAvailableLibraries,
        getAvailableLibraryStructure: getAvailableLibraryStructure,
        getAvailableModelWithTypeAsJson: getAvailableModelWithTypeAsJson,
        cloneSimulationDataModel: cloneSimulationDataModel,
        addNewSimulationDataModelFolder: addNewSimulationDataModelFolder,
        addNewSimulationDataModel: addNewSimulationDataModel,
        renameItem: renameItem,
        deleteItem: deleteItem,
        getModelTypesForLibrary: getModelTypesForLibrary,
        lockItem: lockItem,
        revertItem: revertItem,
        saveItem: saveItem
    };
    function getAvailableLibraries(simulatorId, userId) {
        return $http.get(`api/TestPreparation/SimulationData/AvailableLibraries?simulatorId=${simulatorId}&userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getAvailableLibraryStructure(simulatorId, userId, uniqueId) {
        return $http.get(`api/TestPreparation/SimulationData/AvailableLibraries/${encodeURIComponent(uniqueId)}/Structure?simulatorId=${simulatorId}&userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getAvailableModelWithTypeAsJson(simulatorId, userId, libraryUniqueId, modelUniqueId) {
        return $http.get(`api/TestPreparation/SimulationData/AvailableLibraries/${encodeURIComponent(libraryUniqueId)}/Models/${encodeURIComponent(modelUniqueId)}?simulatorId=${simulatorId}&userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function cloneSimulationDataModel(simulatorId, userId, libraryUniqueId, modelUniqueId) {
        return $http.get(`api/TestPreparation/SimulationData/AvailableLibraries/${encodeURIComponent(libraryUniqueId)}/Models/${encodeURIComponent(modelUniqueId)}/clone?simulatorId=${simulatorId}&userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function addNewSimulationDataModelFolder(simulatorId, userId, libraryUniqueId, parentUniqueId) {
        return $http.post(`api/TestPreparation/SimulationData/AvailableLibraries/${encodeURIComponent(libraryUniqueId)}/addModelFolder?simulatorId=${simulatorId}&userId=${userId}&parentUniqueId=${encodeURIComponent(parentUniqueId)}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function addNewSimulationDataModel(simulatorId, userId, libraryUniqueId, parentUniqueId, modelURI) {
        return $http.get(`api/TestPreparation/SimulationData/AvailableLibraries/${encodeURIComponent(libraryUniqueId)}/addModel?simulatorId=${simulatorId}&userId=${userId}&parentUniqueId=${encodeURIComponent(parentUniqueId)}&modelURI=${encodeURIComponent(modelURI)}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function renameItem(simulatorId, userId, libraryUniqueId, itemUniqueId) {
        return $http.post(`api/TestPreparation/SimulationData/AvailableLibraries/${encodeURIComponent(libraryUniqueId)}/${encodeURIComponent(itemUniqueId)}/name?simulatorId=${simulatorId}&userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function deleteItem(simulatorId, userId, libraryUniqueId, itemUniqueId) {
        return $http.post(`api/TestPreparation/SimulationData/AvailableLibraries/${encodeURIComponent(libraryUniqueId)}/${encodeURIComponent(itemUniqueId)}/delete?simulatorId=${simulatorId}&userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getModelTypesForLibrary(simulatorId, userId, libraryUniqueId) {
        return $http.get(`api/TestPreparation/SimulationData/AvailableLibraries/${encodeURIComponent(libraryUniqueId)}/modelTypes?simulatorId=${simulatorId}&userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function lockItem(simulatorId, userId, libraryUniqueId, itemUniqueId) {
        return $http.post(`api/TestPreparation/SimulationData/AvailableLibraries/${encodeURIComponent(libraryUniqueId)}/${encodeURIComponent(itemUniqueId)}/lock?simulatorId=${simulatorId}&userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function revertItem(simulatorId, userId, libraryUniqueId, itemUniqueId) {
        return $http.post(`api/TestPreparation/SimulationData/AvailableLibraries/${encodeURIComponent(libraryUniqueId)}/${encodeURIComponent(itemUniqueId)}/wip?simulatorId=${simulatorId}&userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function saveItem(simulatorId, userId, libraryUniqueId, itemUniqueId) {
        return $http.post(`api/TestPreparation/SimulationData/AvailableLibraries/${encodeURIComponent(libraryUniqueId)}/${encodeURIComponent(itemUniqueId)}?simulatorId=${simulatorId}&userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
});
